(ns common.quantity
  (:require
   [clojure.string         :as string]
   [opengb.dram.quantity   :as qty]
   [opengb.quantity-format :as qf]
   [tailwind-hiccup.core :refer [tw]]))

(def get-magnitude qty/get-magnitude)
(def get-unit qty/get-unit)
(defn quantity? [q?] (and (vector? q?)
                          (= 2 (count q?))))
(def q< qty/q<)
(def q<= qty/q<=)

(defn Q_ [mag unit]
  ;; need our own b/c the dram one requires a lib update for all new units
  (vector (double mag) unit))

(defn Mag
  ([qty] (Mag {} qty))
  ([props qty]
   (when (quantity? qty)
     [:span props (qf/format-quantity qty {:language "en" :region "CA"})])))

(def formatting-opts-for-unit
  {"GJ/year" "GJ"
   "factor"  "x"
   "kWh/m**2/year" "kWh/m²/year"
   "kgCO₂e/m**2/year" "kgCO₂e/m²/year"
   "hr**-1"  "Air Changes per Hour"
   "tCO2e" "tCO₂e"
   "ktCO2e" "kt CO₂e"
   "ft**2" "ft²"})

(defn display-unit
  "How `unit` is written for display, e.g. \"tCO2e\" as \"tCO₂e\"."
  [unit]
  (get formatting-opts-for-unit unit unit))

(defn format-unit
  [qty]
  (display-unit (get-unit qty)))

(defn Unit
  ([qty] (Unit {} qty))
  ([props qty]
   (when (quantity? qty)
     [:span props (format-unit qty)])))

(defn Qty [qty]
  [:span (tw [:whitespace-nowrap]) [Mag (tw [:inline]) qty] " " [Unit (tw [:inline :font-normal]) qty]])

(defn qty-fmap
  "Apply fn to the mag."
  [f qty]
  (Q_ (f (qty/get-magnitude qty)) (qty/get-unit qty)))

(defn safe-for-math?
  "Ensures inputs are both quantities of the same type."
  [lhq rhq]
  (and (quantity? lhq)
       (quantity? rhq)
       (= (get-unit lhq) (get-unit rhq))))

(defn q+
  "Adds two quantities. If quantities are not the same unit then returns the
  first quantity."
  [lhq rhq]
  (if (safe-for-math? lhq rhq)
    (Q_ (+ (get-magnitude lhq) (get-magnitude rhq)) (get-unit lhq))
    lhq))

(defn q-
  "Subtracts two quantities. If quantities are not the same unit then returns
  the first quantity."
  [lhq rhq]
  (if (safe-for-math? lhq rhq)
    (Q_ (- (get-magnitude lhq) (get-magnitude rhq)) (get-unit lhq))
    lhq))

(defn qdiv
  "Divides two quantities. If quantities are not the same unit then returns the
  first quantity. If second quantity (denominator) has magnitude of 0 then
  returns nil."
  [lhq rhq]
  (if (safe-for-math? lhq rhq)
    (let [lh-mag (get-magnitude lhq)
          rh-mag (get-magnitude rhq)]
      (when (not (zero? rh-mag))
        (Q_ (/  lh-mag rh-mag) (get-unit lhq))))
    lhq))

(defn rate-quantity-multiply
  "Multiplies a rate quantity by a quantity whose unit matches the rate's
  denominator, cancelling it: [a \"X/Y\"] * [b \"Y\"] = [a*b \"X\"].
  Returns nil if the units don't meet this requirement."
  [rate rhq]
  (let [[numerator denominator :as parts] (string/split (get-unit rate) #"/")]
    (when (and (= 2 (count parts))
               (= denominator (get-unit rhq)))
      (Q_ (* (get-magnitude rate) (get-magnitude rhq)) numerator))))
